export class Motd {
	id:number = 0;
	translations:{[key:string]:string}= {};
	expirationDate:Date = new Date();

	public constructor(data?:any){
		if (!data) return;
		this.id = data.id;
		this.translations = data.translations;
		this.expirationDate = new Date(data.expirationDate);
	}

	public getJSON(){
		return {
			id: this.id,
			translations: this.translations,
			expirationDate: this.expirationDate
		};
	}
}